module.exports = __webpack_public_path__ + "static/media/9.72eae249.png";